module.exports = __webpack_public_path__ + "img/1-1.64f8a0f9.svg";